const dropdowns = document.querySelectorAll('.gform_wrapper .gform_body .dropdown-toggle')
if (dropdowns) {
  const dropdownBoxes = document.querySelectorAll('.gform_wrapper .gform_body .dropdown-box')
  Array.prototype.forEach.call(dropdowns, (dd, i) => {
    dd.addEventListener('click', () => {
      dd.classList.toggle('active')
      dropdownBoxes[i].classList.toggle('active')
    })
  })
}

// upload file field

function uploadInputSettings () {
  const uploadInputWrappers = document.querySelectorAll('.ginput_container_fileupload')
  if (uploadInputWrappers) {
    Array.prototype.forEach.call(uploadInputWrappers, (uploadInputWrapper) => {
      const uploadInput = uploadInputWrapper.querySelector('input[type=file]')
      window.setTimeout(() => {
        uploadInput.setAttribute('size', '10')
      }, 1)
      uploadInput.addEventListener('change', () => {
        let fileName = uploadInput.value.split('\\').pop()
        if (fileName) {
          uploadInputWrapper.nextElementSibling.innerHTML = fileName
        } else {
          uploadInputWrapper.nextElementSibling.innerHTML = defaultText
        }
      })
    })
  }
}
uploadInputSettings()